// extracted by mini-css-extract-plugin
export default {"container":"container__SXeaU","label":"label__fSHza","box":"box__u4hdY","check":"check__GIIz_","minus":"minus__X62yj","checkbox":"checkbox__EJECe"};